export function endsWithPeriod(sentence: string): 0 | 1 {
  return sentence.trim().endsWith(".") ? 1 : 0;
}
